module.exports = __webpack_public_path__ + "static/media/corner-up-left-alt.c335f277.svg";